/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-04-14T19:21:18.573
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportStorageIntention,
	listReportStorageIntentionInit,
	listReportStorageIntentionByAuthorizations,
	deleteReportStorageIntention
	
} from '@api/report/ReportStorageIntention';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportStorageIntention({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportStorageIntention(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportStorageIntentionByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportStorageIntentionByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportStorageIntentionInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportStorageIntentionInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportStorageIntention({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportStorageIntention({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
